<template>
  <v-layout row>
    <v-flex xs12 sm8 offset-sm2 lg4 offset-lg4>
      <v-card>
        <progress-bar :show="busy"></progress-bar>
        <v-card-title primary-title>
          <h3 class="headline mb-0">{{ $t('reset_password') }}</h3>
        </v-card-title>
        <div v-show="!success">
          <form @submit.prevent="send" @keydown="form.onKeydown($event)" v-show="!success">

            <v-card-text>
              <!-- Email -->
              <email-input
                :form="form"
                :label="$t('email')"
                :v-errors="errors"
                :value.sync="form.email"
                name="email"
                v-validate="'required|email'"
              ></email-input>

            </v-card-text>
            <v-card-actions>
              <submit-button :flat="true" :form="form" :label="$t('send_password_reset_link')"></submit-button>
            </v-card-actions>
          </form>
        </div>
        <v-card-text>
          <v-alert
            :value="success"
            type="success"
          >
            You will soon receive an email with a link to reset your password!
          </v-alert>

          <v-alert
            :value="formError!=''"
            type="error"
          >
            {{ formError }}
          </v-alert>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Form from 'vform'

export default {
  name: 'email-view',
  
  metaInfo () {
    return { title: this.$t('reset_password') }
  },

  data: () => ({
    form: new Form({
      email: ''
    }),
    success: false,
    formError: ''
  }),

  methods: {
    async send () {
      if (await this.formHasErrors()) return
      this.busy = true

      const { data } = await this.form.post(process.env.API_URL+'/password_email')

      if(data.success){
        this.success = true
        this.formError = ''
      } else if(data.error) {
        this.formError = data.error
      } else {
        this.formError = "Sorry, somthing went wrong. Please reload the page and try again."
      }

      this.busy = false

    }
  }
}
</script>



// WEBPACK FOOTER //
// email.vue?76102730